<template>
  <profile-view
    :client="client"
    :invite-client="inviteClient"
    :group-service="groupService"
    :initial-family-members="familyMembers"
    :account-client="accountClient"
    :api-token-client="apiTokenClient"
    :initial-api-tokens="apiTokens"
  />
</template>

<script lang="ts">
  import ProfileClient from '@/service/profile/profileClient';
  import InviteClient from '@/service/invite/inviteClient';
  import GroupService from '@/service/group/groupService';
  import ProfileView from '@/views/profile/ProfileView.vue';
  import AccountClient from '@/service/account/accountClient';
  import ApiTokenClient from '@/service/apiTokens/apiTokenClient';
  import { firebase } from '@/config/Firebase';
  import { defineComponent } from 'vue';
  import { getCurrentUser, useFirebaseStorage, useFirestore } from 'vuefire';
  import type { User } from 'firebase/auth';

  export default defineComponent({
    name: 'ProfileViewRoute',
    components: { ProfileView },
    async setup() {
      const user = (await getCurrentUser()) as User;
      const firestore = useFirestore();
      const profileClient = new ProfileClient(
        user,
        firestore,
        useFirebaseStorage(),
      );
      const inviteClient = new InviteClient(firestore, user.uid);
      const groupService = new GroupService(firestore, user.uid);
      const familyMembers = await groupService.getMemberProfiles();
      const apiTokenClient = new ApiTokenClient(firestore, user.uid);
      const apiTokens = await apiTokenClient.list();

      return {
        client: profileClient,
        inviteClient,
        groupService,
        familyMembers,
        accountClient: new AccountClient(firestore, firebase.functions, user),
        apiTokenClient,
        apiTokens,
      };
    },
  });
</script>
